import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { Ellipsis } from '../loaders';
import { Body3 } from '../styled';
import tusdIconUrl from '../../images/tusd-icon.png';
import chainlinkUrl from '../../images/chainlink.png';

const TickerContainer = styled.div`
  position: relative;
  background: #05080F;
  color: white;
  height: 32px;
  line-height: 32px;
  padding-left: 32px;
  font-size: 14px;

  @media (max-width: 480px) {
    padding-left: 10px;
  }
`;

const CurrencyIcon = styled.img`
  position: relative;
  top: 5px;
  height: 20px;
  margin-right: 12px;
`;

const ArmaninoIcon = styled.img`
  position: relative;
  top: 4px;
  height: 20px;
  margin-right: 12px;
`;

const DarkText = styled.span`
  color: #7A859E;
`;

const BlText = styled.span`
  margin: 0 5px 0 0;
  color:#7A859E;
`;
const FlText = styled.span`

  margin: 0 10px 0 0;
  color:#FFFFFF;
`;

const LogoContainer = styled.div`
  float: right;
  height: 32px;
`;

const ChainlinkIcon = styled.img`
  position: relative;
  top: 11px;
  height: 20px;
  margin-right: 12px;
`;

function formatNumberWithCommas(num) {
  return num.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function LiveTicker(props) {
  const [tickerState, setTickerState] = React.useState(null);
  React.useEffect(() => {
    const effect = async function () {
      try {
        const armaninoRes = await axios.get(process.env.MINE_NEW_URL)
        if (armaninoRes.status === 200 && armaninoRes.data) {
          const armaninoResData = armaninoRes.data;
          // const armaninoTokenData = armaninoResData.token;
          setTickerState({
            // totalTrust: armaninoResData.totalTrust,
            // totalToken: armaninoResData.totalToken,
            // Ethereum: armaninoTokenData.find(v => v.tokenName === 'TUSD (ETH)').totalTokenByChain || '',
            // TRON: armaninoTokenData.find(v => v.tokenName === 'TUSD (TRON)').totalTokenByChain || '',
            // Avalanche: armaninoTokenData.find(v => v.tokenName === 'TUSD (AVAX)').totalTokenByChain || '',
            // BinanceChain: armaninoTokenData.find(v => v.tokenName === 'TUSD (BNB)').totalTokenByChain || '',
            // BSC: armaninoTokenData.find(v => v.tokenName === 'TUSD (BSC)').totalTokenByChain || '',
            Ethereum: Number(armaninoResData.Ethereum) || '',
            TRON: Number(armaninoResData.TRON) || '',
            Avalanche: Number(armaninoResData.Avalanche) || '',
            BinanceChain: Number(armaninoResData.BinanceChain) || '',
            BSC: Number(armaninoResData.BNBSmartChain) || '',
          });
        } else {
          throw new Error(`Error ${armaninoRes.status},${armaninoRes.data}`)
        }
      } catch (e) {
        console.error(e);
        setTickerState({ error: true });
      }
    };
    effect();
  }, []);

  return (
    <TickerContainer>
      {!tickerState &&
        <Ellipsis />
      }
      {tickerState &&
        <React.Fragment>
          {!tickerState.error &&
            <span>
              <span>
                <CurrencyIcon src={tusdIconUrl} />
                {/* ${formatNumberWithCommas(tickerState.totalTrust)} <DarkText>backing</DarkText> {formatNumberWithCommas(tickerState.totalToken)} TUSD */}
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span>
                <a  style={{textDecoration : "none"}}  href={'https://etherscan.io/address/0x0000000000085d4780b73119b644ae5ecd22b376'} target="_blank" rel="noopener noreferrer"> <BlText >Ethereum</BlText> <FlText >{formatNumberWithCommas(tickerState.Ethereum)}</FlText> </a>
              </span>
              <span>
                <a style={{textDecoration : "none"}}  href={'https://tronscan.org/#/contract/TUpMhErZL2fhh4sVNULAbNKLokS4GjC1F4/code'} target="_blank" rel="noopener noreferrer"><BlText>TRON</BlText> <FlText >{formatNumberWithCommas(tickerState.TRON)}</FlText></a>
              </span>
              <span>
                <a  style={{textDecoration : "none"}}  href={'https://avascan.info/blockchain/c/address/0x1c20e891bab6b1727d14da358fae2984ed9b59eb'} target="_blank" rel="noopener noreferrer"><BlText>Avalanche</BlText> <FlText >{formatNumberWithCommas(tickerState.Avalanche)}</FlText></a>
              </span>
              <span>
                <a style={{textDecoration : "none"}}  href={'https://explorer.binance.org/asset/TUSDB-888'} target="_blank" rel="noopener noreferrer"><BlText>BNB Beacon Chain</BlText><FlText >{formatNumberWithCommas(tickerState.BinanceChain)}</FlText></a>
              </span>
              <span>
                <a style={{textDecoration : "none"}}  href={'https://bscscan.com/address/0x40af3827f39d0eacbf4a168f8d4ee67c121d11c9'} target="_blank" rel="noopener noreferrer"><BlText>BNB Smart Chain</BlText><FlText >{formatNumberWithCommas(tickerState.BSC)}</FlText></a>
              </span>
              {/* <LogoContainer>
                <a href={'https://data.chain.link/ethereum/mainnet/reserves/tusd-por'} target="_blank" rel="noopener noreferrer">
                  <ChainlinkIcon src={chainlinkUrl} />
                </a>
              </LogoContainer> */}
            </span>
          }
        </React.Fragment>
      }
    </TickerContainer>
  );
}

export { LiveTicker };